import { Box, alpha } from "@mui/material";

interface OrbLoaderProps {
  /** Diámetro total del orbe en px. Por defecto 160. */
  size?: number;
}

/**
 * Orbe de espera animado: dos anillos fijos, un barrido cónico giratorio y un halo pulsante.
 * Mismo spec visual que el orbe de `WaitingRoom`.
 */
export const OrbLoader = ({ size = 160 }: OrbLoaderProps) => {
  const innerInset = Math.round(size * 0.17);
  const haloSize = Math.round(size * 0.66);
  const coreSize = Math.round(size * 0.36);

  return (
    <Box
      sx={(theme) => ({
        position: "relative",
        width: size,
        height: size,
        "@keyframes orbLoaderOrbit": {
          from: { transform: "rotate(0deg)" },
          to: { transform: "rotate(360deg)" },
        },
        "@keyframes orbLoaderPulse": {
          "0%": { transform: "translate(-50%, -50%) scale(.7)", opacity: 0.55 },
          "70%": { opacity: 0 },
          "100%": { transform: "translate(-50%, -50%) scale(1.35)", opacity: 0 },
        },
        "& > *": { position: "absolute", borderRadius: "50%" },
        "& .orb-centered": { top: "50%", left: "50%", transform: "translate(-50%, -50%)" },
        "& .orb-ring-outer": { inset: 0, border: `1.5px solid ${alpha(theme.palette.primary.main, 0.28)}` },
        "& .orb-ring-inner": {
          inset: innerInset,
          border: `1px solid ${alpha(theme.palette.primary.main, 0.19)}`,
        },
      })}
    >
      <Box className="orb-ring-outer" />
      <Box className="orb-ring-inner" />
      <Box
        sx={(theme) => ({
          inset: 0,
          animation: "orbLoaderOrbit 2.2s linear infinite",
          background: `conic-gradient(from 0deg, ${alpha(theme.palette.primary.main, 0)} 0deg, ${alpha(
            theme.palette.primary.main,
            0.32,
          )} 160deg, ${alpha(theme.palette.primary.main, 0)} 161deg)`,
        })}
      />
      <Box
        className="orb-centered"
        sx={(theme) => ({
          width: haloSize,
          height: haloSize,
          animation: "orbLoaderPulse 1.6s ease-out infinite",
          bgcolor: alpha(theme.palette.primary.main, 0.16),
        })}
      />
      <Box
        className="orb-centered"
        sx={(theme) => ({
          width: coreSize,
          height: coreSize,
          bgcolor: "primary.main",
          boxShadow: `0 8px 22px ${alpha(theme.palette.primary.main, 0.4)}`,
        })}
      />
    </Box>
  );
};
